var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"justify":"center","cols":"6","sm":"4","md":"3"}},[_c('v-img',{staticClass:"mx-auto",attrs:{"src":_vm.displayImg,"contain":"","width":"40px","height":"auto"}}),_c('p',{staticClass:"text-center",staticStyle:{"word-break":"none"}},[_vm._v(_vm._s(_vm.displayText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }